<template>
  <div>
    <site-header>
      <h1>Blog</h1>
    </site-header>

    <main :class="$style.blog" class="wrap">
      <div :class="$style.blogItems">
        <article :class="$style.item" v-for="post in posts">
          <router-link :to="`/blog/${post.slug}`">
            <div :class="$style.thumbnail" v-if="getImage(post)">
              <img :src="getImage(post)">
            </div>
            <p :class="$style.meta">{{ formatDate(post.date_gmt) }}</p>
            <h2 :class="$style.title">
              <span v-html="post.title.rendered"></span>
            </h2>
          </router-link>
        </article>
      </div>
    </main>

    <loader v-if="loading"></loader>
  </div>
</template>

<script>
  import axios from 'axios';
  import fecha from 'fecha';
  import { get } from 'lodash';
  import SiteHeader from '../components/SiteHeader';
  import Loader from '../components/Loader';

  export default {
    name: 'blog',

    components: {
      SiteHeader,
      Loader,
    },

    data() {
      return {
        loading: true,
        posts: [],
      };
    },

    head: {
      title() {
        return {
          inner: 'Blog',
        };
      },
    },

    methods: {
      getImage(item) {
        // No embeddable image so don't bother
        if (!get(item, '_embedded[\'wp:featuredmedia\'][0].media_details.sizes')) {
          return null;
        }

        // Cache the items and work out which will be the best to use
        const obj = item['_embedded']['wp:featuredmedia'][0].media_details.sizes; // eslint-disable-line

        if (typeof obj.large !== 'undefined') {
          return obj.large.source_url;
        }

        if (typeof obj.medium_large !== 'undefined') {
          return obj.medium_large.source_url;
        }

        if (typeof obj.medium !== 'undefined') {
          return obj.medium.source_url;
        }

        if (typeof obj.full !== 'undefined') {
          return obj.full.source_url;
        }

        return null;
      },
      formatDate(date) {
        return fecha.format(new Date(date), 'DD.MM.YYYY');
      },
    },

    mounted() {
      axios.get('/api/posts').then((response) => {
        this.loading = false;
        this.posts = response.data;
      }).catch(() => {
        this.$router.push('/404');
      });
    },
  };
</script>

<style module lang="postcss">
  .blog {
    padding-right: 1rem;
    padding-bottom: 2rem;
    padding-left: 1rem;
    max-width: 62.5em;

    @media (width >= 50em) {
      padding-right: 4rem;
      padding-left: 4rem;
    }
  }

  .blogItems {
    display: flex;
    flex-wrap: wrap;
    margin-left: -1rem;

    @media (width >= 75em) {
      margin-left: -2rem;
    }

    & a {
      text-decoration: none;
      color: inherit;

      &:hover span {
        color: #777;
        border-color: #777;
      }
    }
  }

  .thumbnail {
    overflow: hidden;
    margin-bottom: 1rem;
    height: 10rem;

    & img {
      transition: transform 4s;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .item {
    width: 100%;
    margin-bottom: 2rem;
    margin-left: 1rem;
    cursor: pointer;
    text-align: center;

    &:last-child {
      margin-bottom: 0;
    }

    & a {
      text-decoration: none;
    }

    @media (width >= 25em) {
      width: calc(50% - 1rem);

      &:nth-last-child(-n+2) {
        margin-bottom: 0;
      }
    }

    @media (width >= 50em) {
      width: calc(33.3333% - 1rem);
      margin-left: 1rem;

      &:nth-last-child(-n+3) {
        margin-bottom: 0;
      }
    }

    @media (width >= 75em) {
      width: calc(33.3333% - 2rem);
      margin-left: 2rem;
    }

    &:hover {
      & .thumbnail img {
        transform: scale(1.1);
      }
    }
  }

  .meta {
    margin-bottom: 0.25rem;
    color: #333;
    font-size: 0.6rem;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
  }

  .title {
    font-size: 1.2rem;

    & span {
      border-bottom: 0.07em solid #999;
    }
  }

  .excerpt {
    font-size: 0.875rem;
    line-height: 1.5;
  }
</style>



// WEBPACK FOOTER //
// Blog.vue?5322b260